$(document).ready(function() {

  $(".single-item_pc").slick({
      fade: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 10000, // 最初のスライドの秒数
      pauseOnHover: false,
      pauseOnDotsHover: false,
      pauseOnFocus: false,
      dots: true,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
  }).on("afterChange", function(event, slick, currentSlide) {

    if (currentSlide === 0){
          // 1枚目2週目以降の秒数
          $(".single-item_pc").slick("slickSetOption", "autoplaySpeed", 10000);
          $('.video1pc').get(0).pause();
          $('.video1pc').get(0).currentTime = 0;
          $('.video1pc').get(0).play();      
    }
    if (currentSlide != 0){
          // その他の秒数
          $(".single-item_pc").slick("slickSetOption", "autoplaySpeed", 5000);
    }
  });

  $(".single-item_sp").slick({
      fade: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 10000, // 最初のスライドの秒数
      pauseOnHover: false,
      pauseOnDotsHover: false,
      pauseOnFocus: false,
      dots: true,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true
  }).on("afterChange", function(event, slick, currentSlide) {

    if (currentSlide === 0){
          // 1枚目2週目以降の秒数
          $(".single-item_sp").slick("slickSetOption", "autoplaySpeed", 10000);
          $('.video1sp').get(0).pause();
          $('.video1sp').get(0).currentTime = 0;
          $('.video1sp').get(0).play();      
    }
    if (currentSlide != 0){
          // その他の秒数
          $(".single-item_sp").slick("slickSetOption", "autoplaySpeed", 5000);
    }
  });  

})